var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstructor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M10 13c-3.338 0-10 1.675-10 5v1.25c0 .688.563 1.25 1.25 1.25h17.5c.688 0 1.25-.562 1.25-1.25V18c0-3.325-6.662-5-10-5M10 10.5c2.762 0 5-2.238 5-5s-2.238-5-5-5-5 2.238-5 5 2.238 5 5 5"
})));
export { SvgInstructor as ReactComponent };
export default __webpack_public_path__ + "ce962f6aba63a3f2a9ce3a1e9d4b76e4.svg";